/**
 * Load the Marketo Forms2 library once per page and reuse it. It must not be reloaded: every load
 * creates a new window.MktoForms2, and whatever bound to the previous one is lost — e.g. LeanData
 * BookIt's onSuccess, so a popup opened a second time would no longer save the lead for the calendar.
 */
const FORMS2_SRC = '//get.sendbird.com/js/forms2/js/forms2.min.js'

let loadingPromise = null

const hasRealMktoForms2 = () => typeof window.MktoForms2?.loadForm === 'function'

function waitForMktoForms2(resolve, reject, startedAt = Date.now()) {
	if (hasRealMktoForms2()) {
		resolve(window.MktoForms2)
		return
	}

	if (Date.now() - startedAt > 15000) {
		loadingPromise = null
		reject(new Error('MktoForms2 did not initialize'))
		return
	}

	window.setTimeout(() => waitForMktoForms2(resolve, reject, startedAt), 20)
}

export function loadMarketoForms2() {
	if (typeof window === 'undefined') {
		return Promise.reject(new Error('Marketo Forms2 is client-only'))
	}

	if (hasRealMktoForms2()) {
		return Promise.resolve(window.MktoForms2)
	}

	if (loadingPromise) return loadingPromise

	loadingPromise = new Promise((resolve, reject) => {
		if (document.querySelector(`script[src="${FORMS2_SRC}"]`)) {
			waitForMktoForms2(resolve, reject)
			return
		}

		const script = document.createElement('script')
		script.src = FORMS2_SRC
		script.onload = () => waitForMktoForms2(resolve, reject)
		script.onerror = () => {
			loadingPromise = null
			reject(new Error('Failed to load Marketo Forms2'))
		}
		document.head.appendChild(script)
	})

	return loadingPromise
}

export default loadMarketoForms2
